// extracted by mini-css-extract-plugin
module.exports = {"reward":"reward_reward__3OQG2"};